.SuccessContainer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    width: 100%
    display: flex
    flex: 1
    flex-direction: column
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    overflow: auto
    box-sizing: border-box
    fill: rgb($globalSettingsBackgroundTertiary)
    stroke: rgb($globalSettingsStrokeSecondary)

.SuccessContainerInner
    width: 100%
    min-height: 100%
    padding: 0 20px
    display: flex
    flex-direction: column
    align-items: center
    flex-shrink: 0
    box-sizing: border-box

.TextItem
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    text-align: center

.Thanks
    font-size: 18px
    font-weight: 700

.GreyContainer
    width: calc(100% + 40px)
    flex: 1
    margin: 0 -20px
    background: rgb($globalSettingsBackgroundTertiary)
    display: flex
    flex-direction: column
    align-items: center
    box-sizing: border-box

.Reference
    width: 120px
    height: 40px
    background: rgb($globalSettingsBackgroundPrimary)
    display: flex
    align-items: center
    justify-content: center
    font-size: 18px
    font-weight: 700
    border-radius: $globalButtonRounding
    box-sizing: border-box

.BookingTitle
    width: 100%
    font-weight: 700
    font-size: 18px
    padding: 0 20px
    box-sizing: border-box

.BookingDate
    width: 100%
    font-size: 12px
    padding: 0 20px
    box-sizing: border-box
    svg
        margin: 0 10px

.BookingInfo
    width: 100%
    font-size: 14px
    padding: 0 20px
    display: flex
    justify-content: space-between
    box-sizing: border-box
    .TotalSum
        font-weight: 700

.SuccessButtonContainer
    width: 100%
    padding: 0 20px
    box-sizing: border-box

.DesktopOnly
    display: none

@media #{$tablet}
    .GreyContainer
        height: 360px
        min-height: 360px
        flex-shrink: 0
    .SpacerDesktop
        display: flex
        flex: 1
    .DesktopOnly
        display: initial
    .MobileOnly
        display: none
    .SuccessButtonContainer
        width: 280px
        padding: 0